module.exports = __webpack_public_path__ + "img/98.d1666967.jpg";